/**
 * 郵便番号から住所を取得するサービス
 * zipcloud API を使用: https://zipcloud.ibsnet.co.jp/doc/api
 */

export interface PostalCodeResult {
  address1: string; // 都道府県
  address2: string; // 市区町村
  address3: string; // 町域
  kana1: string;
  kana2: string;
  kana3: string;
  prefcode: string;
  zipcode: string;
}

export interface PostalCodeResponse {
  message: string | null;
  results: PostalCodeResult[] | null;
  status: number;
}

/**
 * 郵便番号から住所を取得
 * @param postalCode - 7桁の郵便番号（ハイフンなし）
 * @returns 住所情報
 */
export const fetchAddressByPostalCode = async (
  postalCode: string
): Promise<string | null> => {
  // 郵便番号のバリデーション（7桁の数字）
  if (!/^\d{7}$/.test(postalCode)) {
    throw new Error("郵便番号は7桁の数字で入力してください");
  }

  try {
    const response = await fetch(
      `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${postalCode}`
    );

    if (!response.ok) {
      throw new Error("郵便番号の検索に失敗しました");
    }

    const data: PostalCodeResponse = await response.json();

    // エラーチェック
    if (data.status !== 200 || !data.results || data.results.length === 0) {
      return null; // 該当する住所が見つからない
    }

    // 最初の結果を使用（通常は1件のみ）
    const result = data.results[0];

    // 都道府県 + 市区町村 + 町域 を結合
    const fullAddress = `${result.address1}${result.address2}${result.address3}`;

    return fullAddress;
  } catch (error) {
    console.error("郵便番号検索エラー:", error);
    throw error;
  }
};
